import { IMultipleReviewPdfService } from "./";
import { PDFConfig } from "@/shared/pdf/config";
import { PDFStyles } from "@/shared/pdf/style";
import { Utilities as _utils } from '@/shared/utilities';
import { i18n } from "@/plugins/i18n";
import { Locales } from "@/i18n/locales";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class MultipleReviewReport implements IMultipleReviewPdfService {
    reviewInfo: any = {};
    docdefinition: any = {};
    categories: any = [];
    metadata: any = {};
    user: string;
    reviewer: string;
    printedDate: string;
    ApplicationId: number;
    userId: number;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    generate(options: any) {
        //to put users review first

        if (Array.isArray(options.data)) {
            options.data.forEach((element, i) => {
                if (element.reviewerId == options.userId) {
                    options.data.splice(i, 1);
                    options.data.unshift(element);
                }    
            });
            this.reviewInfo = options.data
        }
        else {
            this.reviewInfo = options.data
        }

        this.categories = options.categories;
        this.metadata = options.metadata;
        this.user = options.user;
        this.ApplicationId=options.ApplicationId;

        
        this.printedDate = this.formatDate(new Date());

        this.buildDocDefinition(this.reviewInfo);

        /** Create the pdf file & download */
        pdfMake
            .createPdf(this.docdefinition)
            .download(`tag_review_${Array.isArray(this.metadata) ? this.metadata[0]['Title'] : this.metadata['Title']}_${this.metadata[0].Code || this.ApplicationId}.pdf`);
    }

    print(data: any, categoriesInfo: any, user: string) {
        this.reviewInfo = data;
        this.categories = categoriesInfo;
        this.metadata = {}; //apllicationInfo;

        this.buildDocDefinition(this.reviewInfo);

        /** Create the pdf file & download */
        pdfMake
            .createPdf(this.docdefinition)
            .download(`iucn_aplication_review.pdf`);
    }

    buildDocDefinition(data) {
        let reviewCount=0
        this.docdefinition.content = new Array<any>();

        /** document style css */
        this.docdefinition.styles = PDFStyles.appl;

        /** document page margins */
        this.docdefinition.pageMargins = PDFConfig.pageMargins;
        const applicationId = Array.isArray(this.metadata) ? this.metadata[0].ApplicationId : data.applicationId;
        
        //to create multiple reviews
        
        if (Array.isArray(data) && Array.isArray(this.metadata)) {
            data.forEach(info => {
                this.metadata.forEach(meta => {
                    if (info.reviewerId == meta.ReviewerId) {
                        reviewCount=reviewCount+1;
                        this.createCoverPage(info, meta,reviewCount);

                        this.setHeader(meta.Code);

                        this.setFooter(this.user, this.printedDate);

                        // #. print review form if status is COI dis agreed
                        if (this.metadata['Status'] !== 'COI Disagreed') {
                            this.reviewData(info, this.categories);
                        }
                    }
                })
            })
        }
        else {
            this.createCoverPage(this.reviewInfo, this.metadata,reviewCount);

            this.setHeader(this.metadata.Code);

            this.setFooter(this.user, this.printedDate);

            // #. print review form if status is COI dis agreed
            if (this.metadata['Status'] !== 'COI Disagreed') {
                this.reviewData(data, this.categories);
            }

        }
    }

    createCoverPage(reviewInfo, metadata,reviewCount) {
        this.docdefinition.content.push({
            text: `${i18n.t('Project title')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 80, 0, 5],
            alignment: 'center',
            pageBreak:reviewCount<=1?"":"before"
        });

        this.docdefinition.content.push({
            text: metadata.Title,
            style: ['covertext', 'header1']
        });

        this.docdefinition.content.push({
            text: `${i18n.t('Name of Grant Activity')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 30, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: metadata.Initiative,
            style: ['covertext', 'header1']
        });

        this.docdefinition.content.push({
            text: `${i18n.t('Lead partner')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 30, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: metadata.LeadPartner,
            style: ['covertext', 'header1']
        });

        this.docdefinition.content.push({
            columns: [
                {
                    text: `${i18n.t('Project duration')}`,
                    style: ["header3"],
                    margin: [0, 25, 0, 5],
                    alignment: "center",
                },
                {
                    text: `${i18n.t('Total project budget')}`,
                    style: ["header3"],
                    margin: [0, 25, 0, 5],
                    alignment: "center",
                },
                {
                    text: `${i18n.t('Funding request')}`,
                    style: ["header3"],
                    margin: [0, 25, 0, 5],
                    alignment: "center",
                },
            ]
        });

        var totProjectBudget = _utils.formatCurrency(metadata.TotalProjectBudget,metadata.BudgetCurrency, this.defaultLocale) || _utils.formatCurrency(0,metadata.BudgetCurrency, this.defaultLocale);
        var reqAmt = _utils.formatCurrency(metadata.RequestedAmount,metadata.BudgetCurrency, this.defaultLocale) || _utils.formatCurrency(0,metadata.BudgetCurrency, this.defaultLocale);

        this.docdefinition.content.push({
            columns: [
                {
                    text: metadata.ProjectDuration || '-',
                    style: ['covertext'],
                    alignment: "center",
                },
                {
                    text: totProjectBudget.replace(/\u202F/g, " "),
                    style: ['covertext'],
                    alignment: "center",
                },
                {
                    text: reqAmt.replace(/\u202F/g, " "),
                    style: ['covertext'],
                    alignment: "center",
                },
            ]
        });

        this.docdefinition.content.push({
            text: `${i18n.t('Reviewed by')}`,
            style: ['covertext', 'coverTitle'],
            margin: [0, 30, 0, 5],
            alignment: 'center'
        });

        this.docdefinition.content.push({
            text: metadata.Reviewer,
            style: ['covertext', 'header1']
        });

        if (metadata['Status'] === 'COI Disagreed') {
            this.docdefinition.content.push({
                text: `${i18n.t('Review status:')}`,
                style: ['covertext', 'coverTitle'],
                margin: [0, 20, 0, 5],
                alignment: 'center'
            });
            this.docdefinition.content.push({
                text: metadata.Status,
                style: ['covertext'],
                alignment: "center",
            });

            this.docdefinition.content.push({
                text: `${i18n.t('Conflict of interest:')}`,
                style: ['covertext', 'coverTitle'],
                margin: [0, 20, 0, 5],
                alignment: 'center'
            });
            this.docdefinition.content.push({
                text: this.metadata[`${i18n.t('Comments')}`],
                style: ['covertext'],
                alignment: "center",
            })
        } else {
            this.docdefinition.content.push({
                columns: [
                    {
                        text: `${i18n.t('Review Status:')}`,
                        style: ["header3"],
                        margin: [0, 25, 0, 5],
                        alignment: "center",
                    },
                    {
                        text: `${i18n.t('Total score')}`,
                        style: ["header3"],
                        margin: [0, 25, 0, 5],
                        alignment: "center",
                    },
                    {
                        text: `${i18n.t('Recommendation')}`,
                        style: ["header3"],
                        margin: [0, 25, 0, 5],
                        alignment: "center"

                    }
                ],
            });

            this.docdefinition.content.push({
                columns: [

                    {
                        text: metadata.Status,
                        style: ['covertext'],
                        alignment: "center",
                    },
                    {
                        text: reviewInfo.totalScore || 0,
                        style: ['covertext'],
                        alignment: "center",
                    },
                    {
                        text: reviewInfo.recommendation,
                        style: ['covertext'],
                        alignment: "center",
                    }
                ],
            });

        }
    }

    /** get the default recommendation */
    getRecommendation(reviewInfo) {

        if (this.categories && this.categories.length > 0) {
            if (reviewInfo.totalScore && reviewInfo.totalScore > (this.categories.length * 3)) {
                return `${i18n.t('Yes')}`;
            } else {
                return `${i18n.t('No')}`;
            }
        } else {
            return `${i18n.t('No')}`;
        }
    }

    setHeader(id) {
        this.docdefinition.header = [
            {
                columns: [
                    {
                        image:
                            "data:image/png;base64,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",
                        height: 25,
                        width: 26,
                        margin: 20,
                        alignment: "left",
                    },
                    {
                        text: "IUCN Grants Portal",
                        style: ["header3"],
                        margin: [30, 25],
                        alignment: "left",
                    },
                    {
                        text: `${i18n.t('Application No:')} ${id}`,
                        style: ["header3"],
                        margin: [30, 25],
                        alignment: "right",
                    },
                ],
            },
        ];
    }

    setFooter(user: string, printedDate: string) {
        /** set page footer */
        this.docdefinition.footer = function (
            currentPage: number,
            pageCount: number
        ) {
            if (currentPage > 1)
                return [
                    {
                        columns: [
                            {
                                // printed by
                                text: `${i18n.t('Printed by')}  :  ${user}`,
                                fontSize: 8,
                                margin: [20, 3, 0, 0],
                                alignment: 'left'
                            },
                            {
                                // page number
                                text: '-' + currentPage.toString() + '-',
                                fontSize: 6,
                                margin: [0, 3, 0, 0],
                                alignment: 'center'
                            },
                            {
                                // printed date
                                text: `${i18n.t('Printed on')}  :  ${printedDate}`,
                                fontSize: 8,
                                margin: [0, 3, 20, 0],
                                alignment: 'right'
                            }
                        ]
                    }
                ];
        };
    }

    private formatDate(date: any) {
        return _utils.formatDate(date);
    }

    reviewData(data: any, catagories: any) {
        this.docdefinition.content.push(
            {
                canvas: [{ type: "rect", x: 0, y: 0, w: 500, h: 30, color: "#19719e" }],
                pageBreak: "before",
                margin: [0, 0, 0, 0],
            },
            {
                text: `${i18n.t('Review')}`,
                color: "#fff",
                relativePosition: { x: 20, y: -23 },
            }
        );
        this.categories.forEach((catg) => {
            var body = [];

            body.push([{ text: catg.Title, colSpan: 2, style: ['tblheader'] }, {}]);

            const review = (data.reviews || []).find(x => x.categoryId === catg.CategoryId);

            body.push([
                { text: catg.Description },
                {
                    columns: [
                        {
                            width: "*",
                            text: `${i18n.t('Rating:')}`,
                            alignment: "right",
                            margin: [0, 12, 2, 0]
                        },
                        {
                            width: "*",
                            text: (review) ? review.rating || '' : '',
                            bold: true,
                            fontSize: 18,
                            margin: [2, 10, 0, 0]
                        },
                    ]
                }
            ]);

            body.push([{ text: `${i18n.t('Comments')}`, colSpan: 2, bold: true, style: ['tbltitle'] }, {}]);

            body.push([{ text: (review) ? review.reviewComment || '' : '', colSpan: 2, style: ['tblcell'] }, {}]);

            this.docdefinition.content.push(
                {
                    table: {
                        widths: ["70%", '30%'],
                        body,
                        margin: [0, 10, 0, 10]
                    },
                    margin: [0, 10, 0, 10]
                }
            )

        })
        this.docdefinition.content.push(
            {
                canvas: [{ type: "rect", x: 0, y: 0, w: 500, h: 30, color: "#19719e" }],
                margin: [0, 10, 0, 0],
            },
            {
                text: `${i18n.t('Overall rating')}`,
                color: "#fff",
                relativePosition: { x: 20, y: -25 },
            }
        );

        this.docdefinition.content.push({
            columns: [
                {
                    text: `${i18n.t('Total score')}`,
                    style: ["tblcell"],
                    margin: [0,5, 0, 5],
                    alignment: "center",
                },
                {
                    text: `${i18n.t('Recommendation')}`,
                    style: ["tblcell"],
                    margin: [0,5, 0, 5],
                    alignment: "center"

                },

            ]
        });

        this.docdefinition.content.push({
            columns: [

                {
                    text: data['totalScore'] || 0,
                    style: ['covertext'],
                    alignment: "center",
                },
                {
                    text: data['recommendation'] || this.getRecommendation(data),
                    style: ['covertext'],
                    alignment: "center",
                },

            ]
        });
            this.docdefinition.content.push({
                text: `${i18n.t('Comment')}`,
                alignment: "left",
                bold: true,
                style: ['tbltitle']
            });
            this.docdefinition.content.push({
                text: data['comment']?data['comment']:"",
                alignment: "left",
                style: ['tblcell'],
            });
    }
}
